export const StatusColors = {
  // Processing Status Colors
  UNPROCESSED: {
    bg: "bg-gray-100",
    text: "text-gray-400",
  },
  ITEMS_ADDED: {
    bg: "bg-yellow-100",
    text: "text-yellow-400",
  },
  PROCESSED: {
    bg: "bg-blue-100",
    text: "text-blue-400",
  },

  // Approval Status Colors
  PENDING: {
    bg: "bg-orange-100",
    text: "text-orange-400",
  },
  APPROVED: {
    bg: "bg-green-100",
    text: "text-green-400",
  },
  REJECTED: {
    bg: "bg-red-100",
    text: "text-red-400",
  },

  // Employment Status Colors
  ACTIVE: {
    bg: "bg-indigo-100",
    text: "text-indigo-400",
  },
  RESIGNED: {
    bg: "bg-purple-100",
    text: "text-purple-400",
  },
} as const;
